// import Head from "next/head";
// import { convertToISO8601 } from "@/utils/dateTimeFormat";
// import { getPlainText } from "@/utils/articleHtmlSplit";

// function createLiveBlogUpdate(events) {
//   const updateEvents = [];
//   events && events.forEach((event) =>
//     updateEvents.push({
//       "@type": "BlogPosting",
//       headline: event.title,
//       datePublished: convertToISO8601(event.datetime_updated),
//       articleBody: getPlainText(
//         event.description
//           ? event.description
//               ?.replace(/<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi, "")
//               ?.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, "")
//           : ""
//       ),
//     })
//   );
//   return updateEvents;
// }

// const LiveBlogSchema = ({ liveblogData }) => {
//   const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
//   // console.log("description_short", liveblogData?.description_short);
//   //* remove twitter embed or any kind script from short description
//   let description = liveblogData?.description_short
//     ?.replace(/<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi, "")
//     ?.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, "");

//   // console.log("description", liveblogData?.content);
//   return (
//     <Head>
//       <script
//         id="LiveBlogPostingSchema"
//         type="application/ld+json"
//         dangerouslySetInnerHTML={{
//           __html: JSON.stringify({
//             "@context": "https://schema.org",
//             "@type": "LiveBlogPosting",
//             "@id": `${websiteUrl}${liveblogData?.seo_detail?.canonical_url}`,
//             about: {
//               "@type": "Event",
//               name: liveblogData?.title,
//               startDate: convertToISO8601(liveblogData?.datetime_published),
//               description: description,
//               endDate: convertToISO8601(liveblogData?.live_blog_end_time),
//               eventAttendanceMode: "mixed",
//               eventStatus: "live",
//               image: liveblogData?.image_main,
//               location: {
//                 address:
//                   "FC8, Film City, Sector 16A Noida, Uttar Pradesh, India",
//                 name: "India",
//               },
//             },
//             datePublished: convertToISO8601(liveblogData?.datetime_published),
//             dateModified: convertToISO8601(
//               liveblogData?.datetime_updated || liveblogData?.live_blog_end_time
//             ),
//             coverageStartTime: convertToISO8601(
//               liveblogData?.datetime_published
//             ),
//             coverageEndTime: convertToISO8601(liveblogData?.live_blog_end_time),
//             headline: liveblogData?.title,
//             ...(liveblogData?.seo_detail?.meta_keyword && { keywords: liveblogData?.seo_detail?.meta_keyword }),
//             description: getPlainText(description),
//             liveBlogUpdate: createLiveBlogUpdate(liveblogData?.content),
//           }),
//         }}
//       ></script>
//     </Head>
//   );
// };

// export default LiveBlogSchema;

// --------------------------------------------------------------------------
import Head from "next/head";
import { convertToISO8601 } from "@/utils/dateTimeFormat";
import { getPlainText } from "@/utils/articleHtmlSplit";
import siteInfo from "@/constants/siteInfo";

function createLiveBlogUpdate(events, canonical_url, authorName, authorCanonicalUrl, image_main) {
  const updateEvents = [];
  events &&
    events.forEach((event) =>
      updateEvents.push({
        "@type": "BlogPosting",
        headline: event.title,
        datePublished: convertToISO8601(event.datetime_updated),
        dateModified: convertToISO8601(event.datetime_updated),
        image: image_main,
        mainEntityOfPage: canonical_url?.includes(
          process.env.NEXT_PUBLIC_WEBSITE_URL
        )
          ? `${canonical_url}`
          : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
        url:  canonical_url?.includes(
          process.env.NEXT_PUBLIC_WEBSITE_URL
        )
          ? `${canonical_url + "#" + event.id}`
          : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url + "#" + event.id}`,
        articleBody: getPlainText(
          event.description
            ? event.description
                ?.replace(/<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi, "")
                ?.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, "")
            : ""
        ),
        author: {
          "@type": "Person",
          name: authorName,
          url: authorCanonicalUrl?.includes(
            process.env.NEXT_PUBLIC_WEBSITE_URL
          )
            ? `${authorCanonicalUrl}`
            : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
        },
        publisher: {
          "@type": "Organization",
          name: siteInfo?.siteName,
          url: process.env.NEXT_PUBLIC_WEBSITE_URL,
          logo: {
            "@type": "ImageObject",
            url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}${siteInfo?.siteLogo}`,
            height: 60,
            width: 160,
          },
        },
      })
    );
  return updateEvents;
}

const LiveBlogSchema = ({ liveblogData, authorName, authorCanonicalUrl }) => {
  const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;

  const description = liveblogData?.description_short
    ?.replace(/<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi, "")
    ?.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, "");
  const canonical_url = liveblogData?.seo_detail?.canonical_url;
  return (
    <Head>
      <script
        id="LiveBlogPostingSchema"
        key={"LiveBlog_Posting_Schema"}
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LiveBlogPosting",
            "@id": `${websiteUrl}${canonical_url}`,
            headline: liveblogData?.title,
            description: getPlainText(description),
            mainEntityOfPage: canonical_url?.includes(
              process.env.NEXT_PUBLIC_WEBSITE_URL
            )
              ? `${canonical_url}`
              : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
            url:  canonical_url?.includes(
              process.env.NEXT_PUBLIC_WEBSITE_URL
            )
              ? `${canonical_url}`
              : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
            image: liveblogData?.image_main,
            datePublished: convertToISO8601(liveblogData?.datetime_published),
            dateModified: convertToISO8601(
              liveblogData?.content[0]?.datetime_updated || liveblogData?.datetime_updated || liveblogData?.live_blog_end_time
            ),
            coverageStartTime: convertToISO8601(
              liveblogData?.datetime_published
            ),
            coverageEndTime: convertToISO8601(liveblogData?.live_blog_end_time),
            ...(liveblogData?.seo_detail?.meta_keyword && {
              keywords: liveblogData?.seo_detail?.meta_keyword,
            }),
            about: {
              "@type": "Event",
              name: liveblogData?.title,
              startDate: convertToISO8601(liveblogData?.datetime_published),
              endDate: convertToISO8601(liveblogData?.live_blog_end_time),
              description: getPlainText(description),
              eventAttendanceMode: "mixed",
              eventStatus: "Live",
              image: liveblogData?.image_main,
              location: {
                name: "India",
                address:
                  "FC8, Film City, Sector 16A Noida, Uttar Pradesh, India",
              },
            },
            liveBlogUpdate: createLiveBlogUpdate(liveblogData?.content, canonical_url, authorName, authorCanonicalUrl, liveblogData?.image_main),
            author: {
              "@type": "Person",
              name: authorName,
              url: authorCanonicalUrl?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${authorCanonicalUrl}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
            },
            publisher: {
              "@type": "Organization",
              name: siteInfo?.siteName,
              url: process.env.NEXT_PUBLIC_WEBSITE_URL,
              logo: {
                "@type": "ImageObject",
                url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}${siteInfo?.siteLogo}`,
                height: 60,
                width: 160,
              },
            },
          }),
        }}
      ></script>
    </Head>
  );
};

export default LiveBlogSchema;
